import React, { useEffect } from 'react'
import {Helmet}from"react-helmet";
import '../components/Styles/fundd.css'
import ff1 from './ff1.png';
import ff2 from './ff2.png';
import ff3 from './ff3.png';
import ff4 from './ff4.png';
import AOS from 'aos';
import 'aos/dist/aos.css';



const Blogff = () => {
    useEffect(()=>{
        AOS.init();
       
      })
    
  return (
    <div>
                 <Helmet>
      
      <title>Value Investing: The Time to Buy is When  There’s Blood on the Streets</title>
      <meta name="description" content="Value Investing: The Time to Buy is When There’s Blood on the Streets"/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>

        <section className='about__us_main' >
          <h1 style={{lineHeight:"60px"}} data-aos="zoom-in">Introducing a Pioneering Vision: 33% Fund <br /> LP Unveils a Sharia-Compliant Fund of Funds <br /> <br /> Houston, Texas – March 22, 2025</h1>
          
         </section>

<br /><br /><br />

<section>
<div className='funddm'>
 <div className='fundd__row'>
  <div className='fundd__col'>
    <p>We’re delighted to present a transformative milestone for the 33% Fund LP, evolving into a Sharia-compliant fund of funds (FoF) that stands as one of the first of its kind in the United States. This isn’t just a step forward—it’s a bold leap into a new era of investing, where exceptional performance meets unwavering integrity. Designed with precision and purpose, this structure brings ethical clarity to all investors, transcending boundaries and setting a new standard in the American financial landscape.
    </p>
  </div>
  <div className='fundd__col'>
    <img src={ff1} alt="" />
  </div>
 </div>
</div>

<br /> <br />
<div className='funddm'>
<h2>33% Fund LP: A Trailblazing Fund of Funds</h2> 
<p  style={{textAlign:"center"}}>We’re delighted to present a transformative milestone for the 33% Fund LP, evolving into a Sharia-compliant fund of funds (FoF) that stands as one of the first of its kind in the United States. This isn’t just a step forward—it’s a bold leap into a new era of investing, where exceptional performance meets unwavering integrity. Designed with precision and purpose, this structure brings ethical clarity to all investors, transcending boundaries and setting a new standard in the American financial landscape.</p>  
</div>

</section>
  <br /><br />

  <section>
    <div className='funddm2'>
      <div className='fbx1'>
      99% Invested in Sub-Funds
      </div>
    </div>

<div className='vl'></div>

    <div className='funddm2'>
    <div className='fundd2__row'>
      <div className='fundd2__col'>
       <h2>33% Focus Fund</h2>
       <p>High-tech growth stocks, selected for innovation and ethical impact, driving capital appreciation with purpose.</p>
      </div>
<br />
      <div className='fundd2__col'>
      <h2>33% Income Fund</h2>
      <p>Real Estate Investment Trusts (REITs), chosen for stability and income, adhering to Sharia guidelines for real asset integrity.</p>  
      </div>
     <br />
      <div className='fundd2__col'>
        <h2>33% Value Fund</h2>
        <p>Dividend-oriented household stocks, vetted for reliability and ethical operations, delivering steady growth and returns. </p>
        </div>
    </div>
</div>

<div className='vl'></div>
<br />
<div className='funddm2'>
      <div className='fbx1'>
      1% Management Fee
      <p id='tt'>The parent fund retains a modest 1% management fee, ensuring our commitment to stewardship while keeping your capital focused on growth.</p>
            </div>
    </div>

  </section>

<br /><br /> <br />
  <section>
    <div className='funddm3'>

   <h2>The Structure: Expertise Meets Innovation</h2>
   <h3>Master Fund: 33% Fund LP</h3>
   <br />
    <div className='fundd3__row'>
    <div className='fundd3__col'>
      <h2>Role</h2>
      <p>The central hub, investing 99% of its assets into three sub-funds while retaining a 1% management fee.</p>
    </div>
    <br />
    <div className='fundd3__col'>
      <h2>Purpose</h2>
      <p>A single entry point to a diversified portfolio, blending growth, income, and value—all underpinned by Sharia-compliant integrity, pioneering this approach in the US.</p>
    </div>
    </div>
    </div>
  </section>
<br /><br />

<br />
<section>
  <div className='fundd55'>
    <h2>Sub-Funds: Specialist-Led Precision</h2>
    <br />
   <div className='fundd5__row'>
    <div className='fundd5__col'>
       <h2>33% Focus Fund</h2>
      <p>High-tech growth stocks, led by a portfolio manager specializing in innovative, ethical companies.</p>
    </div>
    <br />
    <div className='fundd5__col'>
      <h2>33% Income Fund</h2>
      <p>REITs, overseen by a real estate expert ensuring stable, Sharia-compliant income streams.</p>
    </div>
    <br />
    <div className='fundd5__col'>
      <h2>33% Value Fund</h2>
      <p>Dividend-oriented household stocks, managed by a value investing specialist focused on dependable, principled firms.</p>
    </div>
   </div>
  </div>
</section>
<br /><br /><br />

  <section>




<div className='funddm'>
 <div className='fundd__row'>
  <div className='fundd__col'>
   <h2 style={{textAlign:"left"}}>Why This Matters</h2>
    <p>We’re delighted to present a transformative milestone for the 33% Fund LP, evolving into a Sharia-compliant fund of funds (FoF) that stands as one of the first of its kind in the United States. This isn’t just a step forward—it’s a bold leap into a new era of investing, where exceptional performance meets unwavering integrity. Designed with precision and purpose, this structure brings ethical clarity to all investors, transcending boundaries and setting a new standard in the American financial landscape.
    </p>
  </div>
  <br />
  <div className='fundd__col'>
    <img src={ff2} alt="" />
  </div>
 </div>

 <br />

 <div className='fundd__row'>
  <div className='fundd__col'>
   <img src={ff3} alt="" />
     </div>
  <div className='fundd__col'>
<h2 style={{textAlign:"left"}}>Why Invest Now?</h2>
<p>This is investing, redefined: <br /> 
<b>- Pioneering Performance:</b> <br /> 
A team of expert portfolio managers targets exceptional returns, with a 20% performance fee earned only after your 12% success.  <br />
<b>- Ethical Innovation:</b> <br />
As one of the first of its kind in the US, our Sharia-compliant approach ensures your capital supports meaningful growth. <br />  
<b>- Balanced Excellence:</b> <br />  
Three sub-funds, a low 1% fee, and a structure built to deliver—crafted for today’s discerning investor. </p>
  </div>
 </div>

<br />
 <div className='fundd__row'>
  <div className='fundd__col'>
   <h2 style={{textAlign:"left"}}>Step Into the Future</h2>
    <p>We invite you to explore this trailblazing opportunity. Contact us at <a href="mailto:info@33percentfund.com"  style={{color:"#003889"}}>info@33percentfund.com</a>  to discover how the 33% Fund LP can elevate your portfolio with purpose and precision. This isn’t just a fund—it’s a vision for what investing can become
    </p>
  </div>
  <div className='fundd__col'>
  <img src={ff4} alt="" />
 
  </div>
 </div>



</div>


</section>

<br /><br /><br />
<section>
  <div className='funddm4'>
  Disclaimer: This announcement does not constitute an offer to invest. All investments involve risk and are subject to applicable securities regulations. Past performance is not indicative of future results.
  </div>
</section>
<br /><br /><br />
<section>
  <div className='fflst'>
    <h2>Get Started Today</h2>
    <p>Ready to embark on your investment journey with us? Contact our investor relations team to get started or schedule a one-on-one consultation with one of our portfolio managers.</p>
  </div>
</section>
    </div>
  )
}

export default Blogff;